export const GET_BLOG_ARTICLES = {
  REQUEST: 'GET_BLOG_ARTICLES_REQUEST',
  SUCCESS: 'GET_BLOG_ARTICLES_SUCCESS',
  FAILURE: 'GET_BLOG_ARTICLES_FAILURE',
};
